import Vue from 'vue';
import some from 'lodash/some';
import { Component, Prop } from 'vue-property-decorator';
import { Address } from '@/models/locations';
import { Restaurant } from '@/models';

@Component({
    name: 'CmgCheckoutAddressInfo',
})
export default class CmgCheckoutAddressInfo extends Vue {
    @Prop({ type: Object })
    address?: Address;

    @Prop({ type: Object })
    restaurant?: Restaurant;

    @Prop({ type: Boolean })
    isPickup!: boolean;

    @Prop({ type: String })
    deliveryAddressName!: string;

    get heading(): string {
        return this.isPickup ? 'PICKUP LOCATION' : 'DELIVERY INFO';
    }

    get addressLine2(): string {
        if (!this.address) {
            return '';
        }

        const postalCode = (this.address.postalCode || '').split('-')[0];
        return `${this.address.locality}, ${this.address.administrativeArea} ${postalCode}`;
    }

    get hasDeliveryError(): boolean {
        const customer = this.$appStore.state.customer.profile;
        if (!customer || !customer.isGuest) {
            return false;
        }

        const guestInfoForm = this.$appStore.state.checkout.guest.info;
        return some(guestInfoForm, 'error');
    }
    
    onClickChange(event: any) {
        this.$services.ui.pushEventTargetAsLastSelectedElement(event);
        this.$services.ui.setModalVisibility('findAChipotle', true, {
            mode: this.$services.order.isPickingUp() ? 'pickup' : 'delivery',
        });
        this.$services.ui.firstFocus();
    }
}
